import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The InfoSmallerCompaniesBySector's component.
 */
const InfoSmallerCompaniesBySector = () => (
  <GridContainer padding="0 0 8px" spacing={2}>
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-SmallerCompaniesBySector.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Selecciona el sector del estado que te interesa consultar.</Item>
        <Item>Selecciona el indicador que quieres revisar.</Item>
        <Item>Selecciona si prefieres la distribución mensual o acumulada.</Item>
        <Item>Selecciona la moneda en la que deseas ver los datos: CLP o dólar estadounidense.</Item>
        <Item>Haz clic para visualizar el gráfico o formato tabla.</Item>
        <Item>Tipo de empresa de menor tamaño.</Item>
        <Item>
          Monto transado o número de órdenes de compra u ofertas a licitaciones generadas para cada tipo de empresa de
          menor tamaño.
        </Item>
        <Item>Cada color en la barra apilada representa un tipo de empresa de menor tamaño.</Item>
        <Item>Refleja los meses del año que seleccionaste.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default InfoSmallerCompaniesBySector
